import { render, staticRenderFns } from "./LoginSettingModal.vue?vue&type=template&id=01479e42&scoped=true"
import script from "./LoginSettingModal.vue?vue&type=script&lang=js"
export * from "./LoginSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01479e42",
  null
  
)

export default component.exports